import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRssSquare } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons'
import {
  Box, ListItem, List, Typography, useTheme 
} from '@mui/material'

type AdvisorsAndInvestorsProps = {
  location: { pathname: string }
}

const AdvisorsAndInvestors = ({ location }: AdvisorsAndInvestorsProps) => {
  const [showCareer, setShowCareer] = useState(false)
  const { palette } = useTheme()

  useEffect(() => {
    if (location.pathname.startsWith('/careers')) {
      setShowCareer(true)
    }
  }, [location.pathname])

  return (
    <Box
      component='section'
      sx={{
        pt: { xs: 5, laptop: 12 },
        position: 'relative',
        background:
          'linear-gradient(172.77deg, rgba(7, 14, 31, 0.4) 13.85%, rgba(62, 53, 209, 0.4) 95.18%)',
      }}>
      {!showCareer && (
        <Box
          sx={{
            px: { xs: 2, laptop: 0 },
          }}>
          <Typography variant='h3' sx={{ textAlign: 'center' }}>
            Over 20,000+ sites and applications use RudderStack
          </Typography>
          <List
            sx={{
              display: { xs: 'grid', laptop: 'flex' },
              px: { xs: 2, laptop: 0 },
              maxWidth: 1152,
              mx: 'auto',
              mt: 5,
              mb: { xs: 10, laptop: 16 },
              gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
              li: {
                maxWidth: 110,
                p: 0,
              },
              justifyContent: { laptop: 'space-between' },
              justifyItems: 'center',
            }}>
            <ListItem
              sx={{
                mb: { xs: 1.5, laptop: 0 },
              }}>
              <Box
                component='img'
                src='/images/allbirds-white-logo.svg'
                alt='allbirds'
              />
            </ListItem>
            <ListItem
              sx={{
                mb: { xs: 1.5, laptop: 0 },
              }}>
              <Box
                component='img'
                src='/images/hinge-white-logo.svg'
                alt='Hinge'
              />
            </ListItem>
            <ListItem
              sx={{
                mb: { xs: 1.5, laptop: 0 },
              }}>
              <Box
                component='img'
                src='/images/priceline-white-logo1.svg'
                alt='priceline'
              />
            </ListItem>
            <ListItem
              sx={{
                mb: { xs: 1.5, laptop: 0 },
              }}>
              <Box
                component='img'
                src='/images/stripe-white-logo.svg'
                alt='stripe'
              />
            </ListItem>
            <ListItem
              sx={{
                mb: { xs: 1.5, laptop: 0 },
              }}>
              <Box
                component='img'
                src='/images/ifttt-white-logo.svg'
                alt='IFTTT'
              />
            </ListItem>
          </List>
        </Box>
      )}
      {!showCareer && (
        <Box>
          <Box
            sx={{
              maxWidth: { xs: 384, laptop: 768 },
              mx: 'auto',
              display: 'flex',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                width: 200,
                pl: 5,
              }}>
              <Box
                component='span'
                sx={{
                  fontSize: { xs: 36, laptop: 54 },
                  fontWeight: 700,
                  display: 'block',
                  color: palette.secondary.main,
                }}>
                2019
              </Box>
              <Box
                component='span'
                sx={{
                  color: palette.text.primary,
                  display: 'block',
                }}>
                Company founded
              </Box>
            </Box>
            <Box
              sx={{
                width: {
                  xs: 'calc(100% - 170px)',
                  laptop: 'calc(100% - 220px)',
                },
                position: 'relative',
                pb: 19,
                height: 'auto',
                overflow: 'hidden',
              }}>
              <Box
                component='svg'
                width='100%'
                height={155}
                sx={{
                  position: 'absolute',
                  display: { xs: 'none', laptop: 'block' },
                  top: 10,
                  width: 440,
                }}
                viewBox='0 0 621 155'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M615 155L620.773 145H609.227L615 155ZM0.5 2.5H6.525V0.5H0.5V2.5ZM18.575 2.5H30.625V0.5H18.575V2.5ZM42.675 2.5H54.725V0.5H42.675V2.5ZM66.775 2.5H78.825V0.5H66.775V2.5ZM90.875 2.5H102.925V0.5H90.875V2.5ZM114.975 2.5H127.025V0.5H114.975V2.5ZM139.075 2.5H151.125V0.5H139.075V2.5ZM163.175 2.5H175.225V0.5H163.175V2.5ZM187.275 2.5H199.325V0.5H187.275V2.5ZM211.375 2.5H223.425V0.5H211.375V2.5ZM235.475 2.5H247.525V0.5H235.475V2.5ZM259.575 2.5H271.625V0.5H259.575V2.5ZM283.675 2.5H295.725V0.5H283.675V2.5ZM307.775 2.5H319.825V0.5H307.775V2.5ZM331.875 2.5H343.925V0.5H331.875V2.5ZM355.975 2.5H368.025V0.5H355.975V2.5ZM380.075 2.5H392.125V0.5H380.075V2.5ZM404.175 2.5H416.225V0.5H404.175V2.5ZM428.275 2.5H440.325V0.5H428.275V2.5ZM452.375 2.5H464.425V0.5H452.375V2.5ZM476.475 2.5H488.525V0.5H476.475V2.5ZM500.575 2.5H512.625V0.5H500.575V2.5ZM524.675 2.5H536.725V0.5H524.675V2.5ZM548.775 2.5H560.825V0.5H548.775V2.5ZM572.875 2.5H584.925V0.5H572.875V2.5ZM596.975 2.5H603V0.5H596.975V2.5ZM603 2.5C604.493 2.5 605.915 2.79703 607.21 3.33429L607.977 1.48684C606.442 0.850638 604.761 0.5 603 0.5V2.5ZM613.166 9.2896C613.703 10.5852 614 12.0066 614 13.5H616C616 11.7392 615.649 10.0577 615.013 8.52349L613.166 9.2896ZM614 13.5V19.3958H616V13.5H614ZM614 31.1875V42.9792H616V31.1875H614ZM614 54.7708V66.5625H616V54.7708H614ZM614 78.3542V90.1458H616V78.3542H614ZM614 101.938V113.729H616V101.938H614ZM614 125.521V137.312H616V125.521H614ZM615 155L620.773 145H609.227L615 155ZM0.5 2.5H6.525V0.5H0.5V2.5ZM18.575 2.5H30.625V0.5H18.575V2.5ZM42.675 2.5H54.725V0.5H42.675V2.5ZM66.775 2.5H78.825V0.5H66.775V2.5ZM90.875 2.5H102.925V0.5H90.875V2.5ZM114.975 2.5H127.025V0.5H114.975V2.5ZM139.075 2.5H151.125V0.5H139.075V2.5ZM163.175 2.5H175.225V0.5H163.175V2.5ZM187.275 2.5H199.325V0.5H187.275V2.5ZM211.375 2.5H223.425V0.5H211.375V2.5ZM235.475 2.5H247.525V0.5H235.475V2.5ZM259.575 2.5H271.625V0.5H259.575V2.5ZM283.675 2.5H295.725V0.5H283.675V2.5ZM307.775 2.5H319.825V0.5H307.775V2.5ZM331.875 2.5H343.925V0.5H331.875V2.5ZM355.975 2.5H368.025V0.5H355.975V2.5ZM380.075 2.5H392.125V0.5H380.075V2.5ZM404.175 2.5H416.225V0.5H404.175V2.5ZM428.275 2.5H440.325V0.5H428.275V2.5ZM452.375 2.5H464.425V0.5H452.375V2.5ZM476.475 2.5H488.525V0.5H476.475V2.5ZM500.575 2.5H512.625V0.5H500.575V2.5ZM524.675 2.5H536.725V0.5H524.675V2.5ZM548.775 2.5H560.825V0.5H548.775V2.5ZM572.875 2.5H584.925V0.5H572.875V2.5ZM596.975 2.5H603V0.5H596.975V2.5ZM603 2.5C604.493 2.5 605.915 2.79703 607.21 3.33429L607.977 1.48684C606.442 0.850638 604.761 0.5 603 0.5V2.5ZM613.166 9.2896C613.703 10.5852 614 12.0066 614 13.5H616C616 11.7392 615.649 10.0577 615.013 8.52349L613.166 9.2896ZM614 13.5V19.3958H616V13.5H614ZM614 31.1875V42.9792H616V31.1875H614ZM614 54.7708V66.5625H616V54.7708H614ZM614 78.3542V90.1458H616V78.3542H614ZM614 101.938V113.729H616V101.938H614ZM614 125.521V137.312H616V125.521H614Z'
                  fill='white'
                />
              </Box>
              <Box
                component='svg'
                width={129}
                height={81}
                viewBox='0 0 129 81'
                sx={{
                  position: 'absolute',
                  display: { xs: 'block', laptop: 'none' },
                  left: { xs: -30, laptop: 'inherit' },
                  top: { xs: 20, laptop: 10 },
                  width: { xs: 130, laptop: 440 },
                }}
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M123 81L128.773 71H117.226L123 81ZM0 2H5.55V0H0V2ZM16.65 2H27.75V0H16.65V2ZM38.85 2H49.95V0H38.85V2ZM61.05 2H72.15V0H61.05V2ZM83.25 2H94.35V0H83.25V2ZM105.45 2H111V0H105.45V2ZM111 2C112.493 2 113.915 2.29703 115.21 2.83429L115.977 0.986841C114.442 0.350638 112.761 0 111 0V2ZM121.166 8.7896C121.703 10.0852 122 11.5067 122 13H124C124 11.2392 123.649 9.55768 123.013 8.02349L121.166 8.7896ZM122 13V18.6667H124V13H122ZM122 30V41.3333H124V30H122ZM122 52.6667V64H124V52.6667H122Z'
                  fill='white'
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              color: palette.secondary.main,
              justifyContent: 'space-between',
              maxWidth: { xs: 384, laptop: 784 },
              mx: 'auto',
              position: 'relative',
            }}>
            <Box
              sx={{
                pb: 19,
                position: 'relative',
                width: 'calc(100% - 220px)',
              }}>
              <Box
                component='svg'
                width='100%'
                height={155}
                viewBox='0 0 621 155'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                sx={{
                  position: 'absolute',
                  display: { xs: 'none', laptop: 'block' },
                  top: 10,
                  width: 440,
                  transform: 'scaleX(-1)',
                  left: { xs: 60, laptop: 90 },
                }}>
                <path
                  d='M615 155L620.773 145H609.227L615 155ZM0.5 2.5H6.525V0.5H0.5V2.5ZM18.575 2.5H30.625V0.5H18.575V2.5ZM42.675 2.5H54.725V0.5H42.675V2.5ZM66.775 2.5H78.825V0.5H66.775V2.5ZM90.875 2.5H102.925V0.5H90.875V2.5ZM114.975 2.5H127.025V0.5H114.975V2.5ZM139.075 2.5H151.125V0.5H139.075V2.5ZM163.175 2.5H175.225V0.5H163.175V2.5ZM187.275 2.5H199.325V0.5H187.275V2.5ZM211.375 2.5H223.425V0.5H211.375V2.5ZM235.475 2.5H247.525V0.5H235.475V2.5ZM259.575 2.5H271.625V0.5H259.575V2.5ZM283.675 2.5H295.725V0.5H283.675V2.5ZM307.775 2.5H319.825V0.5H307.775V2.5ZM331.875 2.5H343.925V0.5H331.875V2.5ZM355.975 2.5H368.025V0.5H355.975V2.5ZM380.075 2.5H392.125V0.5H380.075V2.5ZM404.175 2.5H416.225V0.5H404.175V2.5ZM428.275 2.5H440.325V0.5H428.275V2.5ZM452.375 2.5H464.425V0.5H452.375V2.5ZM476.475 2.5H488.525V0.5H476.475V2.5ZM500.575 2.5H512.625V0.5H500.575V2.5ZM524.675 2.5H536.725V0.5H524.675V2.5ZM548.775 2.5H560.825V0.5H548.775V2.5ZM572.875 2.5H584.925V0.5H572.875V2.5ZM596.975 2.5H603V0.5H596.975V2.5ZM603 2.5C604.493 2.5 605.915 2.79703 607.21 3.33429L607.977 1.48684C606.442 0.850638 604.761 0.5 603 0.5V2.5ZM613.166 9.2896C613.703 10.5852 614 12.0066 614 13.5H616C616 11.7392 615.649 10.0577 615.013 8.52349L613.166 9.2896ZM614 13.5V19.3958H616V13.5H614ZM614 31.1875V42.9792H616V31.1875H614ZM614 54.7708V66.5625H616V54.7708H614ZM614 78.3542V90.1458H616V78.3542H614ZM614 101.938V113.729H616V101.938H614ZM614 125.521V137.312H616V125.521H614Z'
                  fill='white'
                />
              </Box>
              <Box
                component='svg'
                width={129}
                height={81}
                viewBox='0 0 129 81'
                sx={{
                  position: 'absolute',
                  display: { xs: 'block', laptop: 'none' },
                  top: 20,
                  width: 130,
                  left: 60,
                  transform: 'scaleX(-1)',
                }}
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M123 81L128.773 71H117.226L123 81ZM0 2H5.55V0H0V2ZM16.65 2H27.75V0H16.65V2ZM38.85 2H49.95V0H38.85V2ZM61.05 2H72.15V0H61.05V2ZM83.25 2H94.35V0H83.25V2ZM105.45 2H111V0H105.45V2ZM111 2C112.493 2 113.915 2.29703 115.21 2.83429L115.977 0.986841C114.442 0.350638 112.761 0 111 0V2ZM121.166 8.7896C121.703 10.0852 122 11.5067 122 13H124C124 11.2392 123.649 9.55768 123.013 8.02349L121.166 8.7896ZM122 13V18.6667H124V13H122ZM122 30V41.3333H124V30H122ZM122 52.6667V64H124V52.6667H122Z'
                  fill='white'
                />
              </Box>
            </Box>
            <Box
              sx={{
                width: 200,
                pl: 5,
              }}>
              <Box
                component='span'
                sx={{
                  fontSize: { xs: 36, laptop: 54 },
                  fontWeight: 700,
                  display: 'block',
                  color: palette.secondary.main,
                }}>
                2020
              </Box>
              <Box
                component='span'
                sx={{
                  color: palette.text.primary,
                  display: 'block',
                }}>
                Seed round
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              color: palette.secondary.main,
              justifyContent: 'space-between',
              maxWidth: { xs: 384, laptop: 784 },
              position: 'relative',
              mx: 'auto',
            }}>
            <Box
              sx={{
                width: 200,
                pl: 5,
              }}>
              <Box
                component='span'
                sx={{
                  fontSize: { xs: 36, laptop: 54 },
                  fontWeight: 700,
                  display: 'block',
                  color: palette.secondary.main,
                }}>
                2021
              </Box>
              <Box
                component='span'
                sx={{
                  color: palette.text.primary,
                  display: 'block',
                }}>
                Series A & opening of India offices and Greenville office
              </Box>
            </Box>
            <Box
              sx={{
                pb: 19,
                position: 'relative',
                width: 'calc(100% - 220px)',
              }}>
              <Box
                component='svg'
                width='100%'
                height={155}
                viewBox='0 0 621 155'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                sx={{
                  position: 'absolute',
                  display: { xs: 'none', laptop: 'block' },
                  top: 10,
                  width: 440,
                }}>
                <path
                  d='M615 155L620.773 145H609.227L615 155ZM0.5 2.5H6.525V0.5H0.5V2.5ZM18.575 2.5H30.625V0.5H18.575V2.5ZM42.675 2.5H54.725V0.5H42.675V2.5ZM66.775 2.5H78.825V0.5H66.775V2.5ZM90.875 2.5H102.925V0.5H90.875V2.5ZM114.975 2.5H127.025V0.5H114.975V2.5ZM139.075 2.5H151.125V0.5H139.075V2.5ZM163.175 2.5H175.225V0.5H163.175V2.5ZM187.275 2.5H199.325V0.5H187.275V2.5ZM211.375 2.5H223.425V0.5H211.375V2.5ZM235.475 2.5H247.525V0.5H235.475V2.5ZM259.575 2.5H271.625V0.5H259.575V2.5ZM283.675 2.5H295.725V0.5H283.675V2.5ZM307.775 2.5H319.825V0.5H307.775V2.5ZM331.875 2.5H343.925V0.5H331.875V2.5ZM355.975 2.5H368.025V0.5H355.975V2.5ZM380.075 2.5H392.125V0.5H380.075V2.5ZM404.175 2.5H416.225V0.5H404.175V2.5ZM428.275 2.5H440.325V0.5H428.275V2.5ZM452.375 2.5H464.425V0.5H452.375V2.5ZM476.475 2.5H488.525V0.5H476.475V2.5ZM500.575 2.5H512.625V0.5H500.575V2.5ZM524.675 2.5H536.725V0.5H524.675V2.5ZM548.775 2.5H560.825V0.5H548.775V2.5ZM572.875 2.5H584.925V0.5H572.875V2.5ZM596.975 2.5H603V0.5H596.975V2.5ZM603 2.5C604.493 2.5 605.915 2.79703 607.21 3.33429L607.977 1.48684C606.442 0.850638 604.761 0.5 603 0.5V2.5ZM613.166 9.2896C613.703 10.5852 614 12.0066 614 13.5H616C616 11.7392 615.649 10.0577 615.013 8.52349L613.166 9.2896ZM614 13.5V19.3958H616V13.5H614ZM614 31.1875V42.9792H616V31.1875H614ZM614 54.7708V66.5625H616V54.7708H614ZM614 78.3542V90.1458H616V78.3542H614ZM614 101.938V113.729H616V101.938H614ZM614 125.521V137.312H616V125.521H614Z'
                  fill='white'
                />
              </Box>
              <Box
                component='svg'
                width={129}
                height={81}
                viewBox='0 0 129 81'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                sx={{
                  position: 'absolute',
                  display: { xs: 'block', laptop: 'none' },
                  top: 20,
                  width: 130,
                  left: 30,
                }}>
                <path
                  d='M123 81L128.773 71H117.226L123 81ZM0 2H5.55V0H0V2ZM16.65 2H27.75V0H16.65V2ZM38.85 2H49.95V0H38.85V2ZM61.05 2H72.15V0H61.05V2ZM83.25 2H94.35V0H83.25V2ZM105.45 2H111V0H105.45V2ZM111 2C112.493 2 113.915 2.29703 115.21 2.83429L115.977 0.986841C114.442 0.350638 112.761 0 111 0V2ZM121.166 8.7896C121.703 10.0852 122 11.5067 122 13H124C124 11.2392 123.649 9.55768 123.013 8.02349L121.166 8.7896ZM122 13V18.6667H124V13H122ZM122 30V41.3333H124V30H122ZM122 52.6667V64H124V52.6667H122Z'
                  fill='white'
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              color: palette.secondary.main,
              justifyContent: 'space-between',
              maxWidth: { xs: 384, laptop: 784 },
              position: 'relative',
              mx: 'auto',
            }}>
            <Box
              sx={{
                pb: 19,
                position: 'relative',
                width: 'calc(100% - 220px)',
              }}
            />
            <Box
              sx={{
                width: 200,
                pl: 5,
              }}>
              <Box
                component='span'
                sx={{
                  fontSize: { xs: 36, laptop: 54 },
                  fontWeight: 700,
                  display: 'block',
                  color: palette.secondary.main,
                }}>
                2022
              </Box>
              <Box
                component='span'
                sx={{
                  color: palette.text.primary,
                  display: 'block',
                }}>
                Series B,
                <br />
                114+ Employees
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {showCareer && (
        <Box
          component='section'
          sx={{
            pb: 11,
          }}>
          <Box
            sx={{
              px: 2,
              maxWidth: 1152,
              mx: 'auto',
              display: 'flex',
              flexDirection: { xs: 'column', laptop: 'row' },
              gap: { xs: 0, laptop: 10 },
            }}>
            <Box sx={{ width: '100%', maxWidth: 360 }}>
              <Typography
                variant='h2'
                sx={{
                  fontSize: { xs: 24, tablet: 54 },
                  letterSpacing: -0.04,
                  textAlign: 'center',
                }}>
                Join our team
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 18, laptop: 24 },
                  mt: 2,
                  textAlign: 'center',
                }}>
                Help us make data engineers the heroes of their companies.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: 819,
                mt: { xs: 2, tablet: 4, laptop: 10.5 },
                '.MuiTypography-body1': {
                  color: 'text.secondary',
                  fontSize: { xs: 18, laptop: 24 },
                  fontWeight: 300,
                  pt: { xs: 2, tablet: 0 },
                  mb: { xs: 2, tablet: 4 },
                  '&:last-child': {
                    mb: 0,
                  },
                },
              }}>
              <Typography>
                We’re looking to build and grow diverse teams in an inclusive
                environment. People do their best work and are happiest when
                they are free to be their unguarded selves. So we expect
                everyone that works at RudderStack brings their whole selves to
                work every day.
              </Typography>
              <Typography>
                We want globally minded individuals who are passionate about the
                work they do, and inspire others around them. We value differing
                perspectives and believe they lead to growth and opportunity.
              </Typography>
              <Typography>
                We have a lot of growth ahead of us, and know not everyone fits
                perfectly into the roles we have listed. If your experience
                isn’t a perfect match for the job description, but you’re still
                a good fit for the role, apply. We want to work with smart
                people who are good at their job, and, a lot of times, those
                people have non-linear career paths.
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      {showCareer && (
        <Box
          component='section'
          sx={{
            pb: 3.5,
            p: {
              fontSize: 24,
              mt: 3,
              fontWeight: 300,
              mb: 5,
            },
            ul: {
              li: {
                fontWeight: 300,
                fontSize: { xs: 18, tablet: 24 },
                // lineHeight: { xs: '160%', tablet: '210%' },
                backgroundImage: 'url("/images/arrow-icon.png")',
                backgroundRepeat: 'no-repeat',
                pl: { xs: 3.5, tablet: 5 },
                backgroundSize: { xs: '15px', tablet: 'auto' },
                backgroundPosition: { xs: '0 7px', laptop: '0 14px' },
                mb: { xs: 0.75, tablet: 0 },
              },
            },
          }}>
          <Box
            sx={{
              maxWidth: 1152,
              width: '100%',
              mx: 'auto',
              px: { xs: 2, desktop: 0 },
            }}>
            <Typography variant='h2' sx={{ letterSpacing: -0.04 }}>
              Benefits
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 18, laptop: 24 },
                mt: 2,
              }}>
              Employee Experience matters the most to us. We want to invest in
              our team, enabling everyone to feel healthy, happy and supported
              while doing their best work at RudderStack.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', tablet: 'row' },
                mt: 5,
              }}>
              <Box sx={{ width: '100%' }}>
                <List
                  disablePadding
                  sx={{
                    color: palette.text.primary,
                    li: {
                      p: 0,
                      py: { desktop: 1 },
                      width: 'auto',
                    },
                  }}>
                  <ListItem>Remote First & Flexible Work Environment</ListItem>
                  <ListItem>Competitive Compensation</ListItem>
                  <ListItem>Company Equity</ListItem>
                  <ListItem>Comprehensive Health Care</ListItem>
                  <ListItem>Flexible Paid Time Off</ListItem>
                </List>
              </Box>
              <Box sx={{ width: '100%' }}>
                <List
                  disablePadding
                  sx={{
                    color: palette.text.primary,
                    li: {
                      p: 0,
                      py: { desktop: 1 },
                      width: 'auto',
                      fontWeight: 300,
                      fontSize: 24,
                      mb: 7.5,
                      '&:last-child': {
                        mb: 0,
                      },
                    },
                  }}>
                  <ListItem>Yearly Continuous Learning Fund</ListItem>
                  <ListItem>WFH Setup Stipend </ListItem>
                  <ListItem>Team Events and Gatherings</ListItem>
                  <ListItem>Parental Leave </ListItem>
                </List>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          width: '95%',
          mx: 'auto',
          textAlign: 'center',
          mt: { xs: 0, laptop: 14 },
        }}>
        <Box
          component='img'
          src='/images/about-map.webp'
          alt='Map'
          sx={{ mx: 'auto' }}
        />
      </Box>
      {showCareer && (
        <Box
          sx={{
            textAlign: 'center',
            py: { xs: 1, laptop: 5 },
          }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: 40, laptop: 50 },
              mb: 1.5,
            }}>
            Join Our Team
          </Typography>
          <Typography variant='body2' sx={{ mb: 2.5 }}>
            Help us make data engineers the heroes of their companies
          </Typography>
          <Box
            component='a'
            href='https://boards.greenhouse.io/rudderstack'
            sx={{
              mb: { xs: 3, tablet: 0 },
              mr: 2,
              display: 'inline-block',
              background: 'linear-gradient(135.55deg,#3e35d1 6.09%,#86f8e0 116.03%)',
              border: 'none',
              borderRadius: 2,
              color: palette.text.primary,
              py: 2,
              px: { xs: 5, laptop: 3 },
            }}
            target='_blank'
            rel='noreferrer'>
            View Open Positions
          </Box>
        </Box>
      )}
      {!showCareer && (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
          }}>
          <Typography
            sx={{
              fontWeight: 700,
              mb: 1.5,
              fontSize: { xs: 24, laptop: 36 },
            }}>
            Keep in touch
          </Typography>
          <List
            sx={{
              gap: 1.25,
              display: 'flex',
              textAlign: 'center',
              justifyContent: 'center',
              li: {
                p: 0,
                width: 'auto',
              },
            }}>
            <ListItem>
              <Box
                component='a'
                href='https://twitter.com/RudderStack'
                sx={{
                  fontSize: 18,
                  width: 40,
                  height: 40,
                  color: palette.text.primary,
                }}
                target='_blank'
                rel='noreferrer'>
                <Box component={FontAwesomeIcon} icon={faTwitter} size='lg' />
              </Box>
            </ListItem>
            <ListItem>
              <Box
                component='a'
                href='https://www.linkedin.com/company/rudderstack'
                sx={{
                  fontSize: 18,
                  width: 40,
                  height: 40,
                  color: palette.text.primary,
                }}
                target='_blank'
                rel='noreferrer'>
                <Box component={FontAwesomeIcon} icon={faLinkedin} size='lg' />
              </Box>
            </ListItem>
            <ListItem>
              <Box
                component='a'
                href='/blog/rss.xml'
                sx={{
                  fontSize: 18,
                  width: 40,
                  height: 40,
                  color: palette.text.primary,
                }}
                target='_blank'>
                <Box component={FontAwesomeIcon} icon={faRssSquare} size='lg' />
              </Box>
            </ListItem>
            <ListItem>
              <Box
                component='a'
                href='https://boards.greenhouse.io/rudderstack'
                sx={{
                  fontSize: 18,
                  width: 40,
                  height: 40,
                  color: palette.background.default,
                }}
                target='_blank'
                rel='noreferrer'>
                <Box
                  component='img'
                  src='/images/greenhouse-logo.png'
                  alt='Greenhouse'
                />
              </Box>
            </ListItem>
          </List>
        </Box>
      )}
    </Box>
  )
}

export default AdvisorsAndInvestors